import { atom, useAtom } from "jotai";

export const equityModalTabs = ["deposit", "transfer", "withdraw"] as const;
export type EquityModalTab = (typeof equityModalTabs)[number];

export const equityModalTabAtom = atom<EquityModalTab>("deposit");

export const useEquityModalTab = () => {
  const [equityModalTab, setEquityModalTab] = useAtom(equityModalTabAtom);

  return {
    equityModalTab,
    setEquityModalTab,
  };
};
